// extracted by css-extract-rspack-plugin
export default {"colorBorderSecondary":"#d1d1d1","borderRadiusSmall":"8px","wrapper":"Separator-module__wrapper___e5K1c"};